import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { IoMdArrowDropright } from "react-icons/io";
import { FaBolt, FaBuilding, FaMoneyBillWave, FaSolarPanel, FaUsersCog } from "react-icons/fa";
import banner2 from "../assets/banner2.jpg";
import commercial from "../assets/commercial.jpg";
import site from "../assets/site.jpg";

const marketContext = [
  "1.3 billion people worldwide live without electricity.",
  "About 600 million of them are in Sub-Saharan Africa.",
  "DOUBLE F SMART ENERGIES ENTERPRISE focuses on practical renewable systems for this gap.",
];

const serviceClusters = [
  {
    title: "Solar Backup and PV Systems",
    desc: "Deployment for residential, industrial, commercial and agriculture operations.",
  },
  {
    title: "Water and Cooling Solutions",
    desc: "Solar water heaters, refrigerators and pumping systems with reliable support.",
  },
  {
    title: "Electrical and Safety Infrastructure",
    desc: "Electrical works plus CCTV, security and fire system implementation and servicing.",
  },
  {
    title: "Technical Maintenance Services",
    desc: "AC, generator, DC and fuel forklift repair, PBX, voice and data installations.",
  },
];

const projectFootprint = [
  {
    title: "Banking and Embassy Delivery",
    desc: "Battery backup and solar implementation with AKIBA Commercial Bank, NMB, Bank of Africa and Malawian Embassy.",
  },
  {
    title: "Regional Surveillance Power",
    desc: "Supply, installation and commissioning of solar systems for surveillance stations in Mpanda and Katavi.",
  },
  {
    title: "Urban Electrical and CCTV Works",
    desc: "Electrical and CCTV installations for commercial apartments and multiple residential houses in Dar es Salaam.",
  },
  {
    title: "Security Infrastructure Support",
    desc: "Security systems implementation at NSSF building in Arusha with maintenance continuity.",
  },
];

const strengthPoints = [
  {
    title: "Financial Capacity",
    copy: "Shareholder-backed capacity and banking access aligned with the global energy-financing challenge in underserved regions.",
    icon: <FaMoneyBillWave />,
  },
  {
    title: "Engineering Capability",
    copy: "Highly motivated, skilled and experienced technical personnel delivering tailored client solutions.",
    icon: <FaUsersCog />,
  },
  {
    title: "Corporate Delivery",
    copy: "Execution record across institutions, government entities, commercial clients and individuals.",
    icon: <FaBuilding />,
  },
  {
    title: "Renewable Focus",
    copy: "Consistent focus on clean and affordable solar solutions for growth and sustainability.",
    icon: <FaSolarPanel />,
  },
];

export default function HomeBanner2() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) return <div className="container mSupportLoading">{getInlineLoader()}</div>;

  return (
    <section className="MainBodySection py-5 fr2-wrap">
      <div className="container">
        <div className="row g-4 align-items-center mb-4">
          <div className="col-lg-7">
            <h2 className="font-bold text-secondary mb-3">Building a World of opportunities in Solar Energy</h2>
            <p className="text-muted mb-3 font-semi-bold">
              DOUBLE F SMART ENERGIES ENTERPRISE is a renewable energy solutions company focused on clean, affordable and reliable power systems for households, institutions and industries.
            </p>
            <ul className="fr2-list mb-3">
              {marketContext.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <button
              className="btn btn-secondary d-inline-flex align-items-center gap-2 fr-btn-pop"
              onClick={() => appContext.navTo({ item: "services" })}
            >
              Explore Services <IoMdArrowDropright size={22} />
            </button>
          </div>

          <div className="col-lg-5">
            <div className="fr2-media-stack">
              <div
                className="fr2-media fr2-media-main"
              >
                <img src={banner2} style={{width:"100%"}} />
              </div>
              
            </div>
          </div>
        </div>

        <div className="fr2-band mb-4">
          <div className="row g-4 align-items-start">
            <div className="col-lg-6">
              <h5 className="font-bold text-secondary mb-3 d-flex align-items-center gap-2">
                <FaBolt className="text-primary" /> Service Clusters
              </h5>
              <div className="fr2-service-list">
                {serviceClusters.map((item) => (
                  <article key={item.title} className="fr2-service-item">
                    <span className="fr2-service-dot" />
                    <div>
                      <h6 className="mb-1">{item.title}</h6>
                      <p className="mb-0 small">{item.desc}</p>
                    </div>
                  </article>
                ))}
              </div>
            </div>
            <div className="col-lg-6">
              <h5 className="font-bold text-secondary mb-3">Project Footprint</h5>
              <div className="fr2-project-list">
                {projectFootprint.map((item) => (
                  <article key={item.title} className="fr2-project-item">
                    <span className="fr2-project-dot" />
                    <div>
                      <h6 className="mb-1">{item.title}</h6>
                      <p className="mb-0 small">{item.desc}</p>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          </div>
        </div>

        
      </div>
    </section>
  );
}
